const defaultManagementFilters = {
    operator: null,
    category: null,
    segment: null,
    is_active: null,
    payment_type: null
}

export default defaultManagementFilters;